export default {
  name: 'MCheckbox',
  model: {
    prop: 'modelValue',
    event: 'change',
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    labelClasses: {
      type: String,
      default: '',
    },
    align: {
      type: String,
      default: 'left',
    },
    inline: {
      type: Boolean,
      default: false,
    },
    grid: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      default: false,
    },
    options: {
      type: Array,
      default: () => [],
    },
    optionClasses: {
      type: String,
      default: '',
    },
    trueValue: {
      default: true,
    },
    falseValue: {
      default: false,
    },
  },
  computed: {
    values() {
      return this.options.map((option) => {
        if (typeof option === 'object') {
          return option;
        }
        return {
          value: option,
          disabled: false,
        };
      });
    },
  },
  methods: {
    shouldBeChecked(option) {
      if (this.modelValue instanceof Array) {
        return this.modelValue.includes(option);
      }
      return this.modelValue === this.trueValue;
    },
    handleItemChange(event) {
      this.$emit('change', event);
    },
  },
};
